import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserIcon, CoinIcon } from './icons/NavIcons';

/**
 * Composant d'écran de connexion requise
 * Affiche un message invitant l'utilisateur à se connecter
 */
const LoginRequired = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className="mb-6">
        <UserIcon className="w-16 h-16 text-bleu1" />
      </div>
      <h2 className="text-h1 text-center mb-4">{t('myEvents.loginRequired')}</h2>
      <p className="text-body text-gray-600 text-center mb-6">{t('myEvents.loginDescription')}</p>
     
      {/* Composant Offer */}
      <div className="bg-gradient-to-r from-bleu1/10 to-bleu3/10 border-2 border-bleu1/30 rounded-xl p-6 mb-8 max-w-md">
        <div className="flex flex-col items-center gap-3 mb-2">
          <CoinIcon className="w-8 h-8 text-gray-700" />
          <h3 className="text-h3 text-bleu2 font-semibold text-center">{t('myEvents.offerTitle')}</h3>
        </div>
        <p className="text-body text-gray-700 text-center font-medium">
          {t('myEvents.offerDescription')}
        </p>
      </div>

      <button 
        onClick={() => navigate('/settings')}
        className="bg-[#2894D8] text-white py-3 px-6 rounded-lg font-medium hover:bg-[#136E9D] transition-colors"
      >
        {t('common.login')}
      </button>
    </div>
  );
};

export default LoginRequired;
